import type { FunctionComponent } from 'react';
import { AtlassianNavigation } from '@atlaskit/atlassian-navigation';
import Account from '@atlassian/account';
import NavLogo from './NavLogo';
import TrelloLogoComponent from './TrelloLogo';
import { useAccountProps } from './useAccountProps';
import { useToken } from '../../Flow/ConsentContextProvider';

const NavContents: FunctionComponent = () => {
  const { serviceType } = useToken();
  return (
    <AtlassianNavigation
      label="site"
      primaryItems={[]}
      renderSignIn={Profile}
      renderProductHome={
        serviceType == 'Trello' ? TrelloLogoComponent : NavLogo
      }
    />
  );
};

const Profile = () => <Account {...useAccountProps()} />;

export default NavContents;
